import { Stack, Typography } from '@mui/material';
import { IGeneralOptions } from 'API/generalOptions/generalOptions';
import { RadioInput } from 'Components/HookFormInputs/RadioInput';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useAppSelector, useDictionary } from 'Hooks';
import { ITherapySuppliers } from 'Interfaces/therapySuppliers';
import { useFormContext } from 'react-hook-form';

const CaregiverGender = () => {
  const { watch } = useFormContext<ITherapySuppliers>();

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.Suppliers
  ).therapySearchForm;

  const generalOptions: IGeneralOptions | null = useAppSelector(
    (generalOptions) => generalOptions.generalOptions.generalOptions
  );

  const gendersId = {
    noGender: -1,
    male: 1,
    female: 2,
  };

  return (
    <Stack
      gap='20px'
      sx={{
        '.MuiSvgIcon-root > path': {
          strokeWidth: '0.833333',
          stroke: '#A020FF',
        },
      }}
      component='fieldset'
    >
      <legend>{dictionary.caregiverGender}</legend>
      <Typography variant='body2'>{dictionary.caregiverGender}</Typography>
      <RadioInput
        options={[
          { value: gendersId.noGender, label: dictionary.no },
          {
            value: generalOptions?.general?.genders[0].id || gendersId.male,
            label: dictionary.male,
          },
          {
            value: generalOptions?.general?.genders[1].id || gendersId.female,
            label: dictionary.female,
          },
        ]}
        name={'gender'}
        externalValue={watch('gender') || gendersId.noGender}
      />
    </Stack>
  );
};

export default CaregiverGender;
